module.exports = __webpack_public_path__ + "static/img/DSC00066-S.17a7aab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC00066-S.jpg
// module id = 4ynX
// module chunks = 0